import { useState, useRef } from "react";
import CreateTab from "./CreateTab";
import LibraryTab from "./LibraryTab";
import { useHistory } from "react-router-dom";
import MainHeaderWithSidebar from "../../layouts/Header/MainHeader";
import MobileHeader from "../../layouts/Header/MobileHeader";
import FixedHeader from "../../layouts/Header/FixedHeader";
import { Helmet } from "react-helmet";
import { Sparkles } from "lucide-react";

export default function CharacterLibrary() {
  const history = useHistory();
  const [searchQuery, setSearchQuery] = useState("");
  const [activeTab, setActiveTab] = useState("library");
  const [selectedCustomCharacter, setSelectedCustomCharacter] = useState(null);
  const [selectedTemplateCharacter, setSelectedTemplateCharacter] = useState(null);

  // Ref to CreateTab's guarded tab-change handler (set by CreateTab via prop)
  const createTabGuardRef = useRef(null);

  const hasSelectedCharacter =
    selectedCustomCharacter !== null || selectedTemplateCharacter !== null;

  const handleClearSelection = () => {
    setSelectedCustomCharacter(null);
    setSelectedTemplateCharacter(null);
  };

  const handleUseCharacter = () => {
    const selectedId = selectedCustomCharacter || selectedTemplateCharacter;
    history.push("/app/speaking-character", { selectedCharacterId: selectedId });
  };

  return (
    <>
      <Helmet>
        <title>Characters</title>
      </Helmet>
      <div
        id="tc_body"
        className="header-fixed header-mobile-fixed subheader-enabled aside-enabled aside-fixed"
      >
        <MobileHeader />
        <div className="d-flex flex-column flex-root">
          <div className="d-flex flex-row flex-column-fluid page">
            <MainHeaderWithSidebar />
            <div
              className="d-flex flex-column flex-row-fluid wrapper"
              id="tc_wrapper"
            >
              <FixedHeader />
              <div
                className="content d-flex flex-column flex-column-fluid"
                id="tc_content"
              >
                <div className="min-h-screen bg-gray-50 character-section-custom-font">
                  <main className="flex-1 bg-gray-50">
                    <div className="max-w-[1800px] mx-auto p-6">
                      <div className="flex items-center justify-between mb-5">
                        <h1 className="form-step-title !text-[24px]">
                          {activeTab === "create"
                            ? "Create Custom Character"
                            : "Character Library"}
                        </h1>

                        <div className="flex gap-2">
                          {activeTab === "library" && (
                            <div className="relative">
                              <i
                                data-lucide="search"
                                className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-gray-500"
                              ></i>
                              <input
                                type="text"
                                placeholder="Search"
                                value={searchQuery}
                                onChange={(e) => setSearchQuery(e.target.value)}
                                className="pl-9 pr-4 py-2 w-64 rounded-lg border border-gray-200 bg-white text-gray-900 placeholder:text-gray-400 focus:border-orange-500/50"
                              />
                            </div>
                          )}
                          <button
                            onClick={() => {
                              setActiveTab("create");
                              handleClearSelection();
                            }}
                            className={`px-5 py-2 rounded-lg font-medium transition-all ${activeTab === "create"
                              ? "bg-orange-500 hover:bg-orange-600 text-white shadow-lg shadow-orange-500/20"
                              : "bg-white text-gray-700 hover:text-gray-900 hover:bg-gray-50 border border-gray-200"
                              }`}
                          >
                            Create Custom Character
                          </button>
                          <button
                            onClick={() => {
                              // If on create tab and guard is registered, route through it
                              if (activeTab === "create" && createTabGuardRef.current) {
                                createTabGuardRef.current("library");
                              } else {
                                setActiveTab("library");
                              }
                              handleClearSelection();
                            }}
                            className={`px-5 py-2 rounded-lg font-medium transition-all ${activeTab === "library"
                              ? "bg-orange-500 hover:bg-orange-600 text-white shadow-lg shadow-orange-500/20"
                              : "bg-white text-gray-700 hover:text-gray-900 hover:bg-gray-50 border border-gray-200"
                              }`}
                          >
                            Character Library
                          </button>
                        </div>
                      </div>

                      {activeTab === "create" && (
                        <CreateTab
                          setActiveTab={setActiveTab}
                          registerGuard={(fn) => { createTabGuardRef.current = fn; }}
                        />
                      )}
                      {activeTab === "library" && (
                        <LibraryTab
                          searchQuery={searchQuery}
                          onSearchChange={setSearchQuery}
                          selectedCustomCharacter={selectedCustomCharacter}
                          selectedTemplateCharacter={selectedTemplateCharacter}
                          onSelectedCustomCharacterChange={setSelectedCustomCharacter}
                          onSelectedTemplateCharacterChange={setSelectedTemplateCharacter}
                        />
                      )}
                    </div>
                  </main>

                  {/* Floating selection bar */}
                  {/* {hasSelectedCharacter && (
                    <div className="fixed bottom-0 left-0 right-0 z-50 border-t border-gray-200 bg-white/80 backdrop-blur-lg">
                      <div className="max-w-7xl mx-auto px-6 py-4 flex justify-end">
                        <button
                          onClick={handleUseCharacter}
                          className="h-12 px-8 bg-orange-500 hover:bg-orange-600 text-white text-base font-semibold shadow-lg shadow-orange-500/30 rounded-xl flex items-center gap-2"
                        >
                          <Sparkles className="h-5 w-5" />
                          Use Selected Character
                        </button>
                      </div>
                    </div>
                  )} */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
